import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import Actions from "./Actions";
import MessageToSend from "./MessageToSend";
import Title from "./Title";

const CreateOneOOneM = withLiteObserverAndTheme(() => {
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1510}
      height={400}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <Title />

      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <MessageToSend />
      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <Actions />
    </ET3Div>
  );
});

export default CreateOneOOneM;
